import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface OrderReceiptResponse {
    order_idx: number;
    order_number: string;
    customer_name: string;
    order_name: string;
    product_name: string;
    sales_amount: number;
    order_amount: number;
    wreath_word: string;
    search_word: string;
    recipient_name: string;
    recipient_mobile: string;
    department: string;
    company_tel: string;
    delivery_post: string;
    delivery_address: string;
    delivery_address_detail: string;
    delivery_date: string;
    delivery_time: string;
    delivery_memo_idx: number;
    delivery_memo: string;
    wreath_sender: string;
    related_person: string;
    customer_request: string;
    product_quantity: number;
    event_content: {
        event_content_idx: number;
        depth1_idx: number;
        depth1: string;
        depth2: string;
        event_content: string;
    };
}

interface OrderReceiptRequest {
    order_idx: number[];
}

export const usePutReceipt = (
    successCallback?: (data: OrderReceiptResponse[]) => void,
    errorCallback?: (error: any) => void,
): UseMutationResult<OrderReceiptResponse[], Error, OrderReceiptRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<OrderReceiptResponse[], Error, OrderReceiptRequest>({
        mutationFn: async ({ order_idx }: OrderReceiptRequest) => {
            const response = await axios.put<{ data: OrderReceiptResponse[] }>(
                `${enum_api_uri.put_order_receipt}`,
                { order_idx },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                },
            );
            return response.data.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            // 인수증 출력이 히스토리에 기록되므로 상태변경 내역도 갱신한다.
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            successCallback?.(data);
        },
        onError: (error: any) => {
            errorCallback?.(error?.response?.data || error);
        },
    });
};
